import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { CardContent, Divider, Theme } from '@mui/material'

import { useCorporateDetailsViewStore } from './CorporateDetailsView.store'
import { CorporateHeaderBackButton, CorporateHeaderInfo, CorporateHeaderLoading } from './components'

export type CorporateDetailsViewHeaderProps = ExtendableStyles & Testable

export function CorporateDetailsViewHeader({ className, style, ...otherProps }: CorporateDetailsViewHeaderProps) {
  const { classes } = useStyles()
  const {
    state: { corporate, status },
  } = useCorporateDetailsViewStore()
  const isLoading = status === 'loading' && !corporate
  return (
    <CardContent component="header" className={classNames(className, classes.container)} {...otherProps}>
      <CorporateHeaderBackButton className={classes.backButton} />
      <Divider className={classes.divider} orientation="vertical" flexItem />
      {isLoading ? (
        <CorporateHeaderLoading className={classes.headerContent} />
      ) : (
        <CorporateHeaderInfo className={classes.headerContent} corporate={corporate!} />
      )}
    </CardContent>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: spacing(),
  },
  backButton: {
    flex: '0 0 auto',
  },
  divider: {
    margin: spacing(0, 2),
  },
  headerContent: {
    flex: '1 1 auto',
  },
}))
